var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ta-auction-view-no"},[_vm._v(" "+_vm._s(_vm.auction.auction_no)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }